import { api_ } from '@shared/plugIn/axios';

import {
  AccountConfig,
  AccountConfigCreate,
  AccountConfigUpdate,
} from './accountConfig.interface';

/** 전체 AccountConfig 목록 조회 */
export const getAccountConfigs = async (): Promise<AccountConfig[]> => {
  const { data } = await api_.get<AccountConfig[]>('admin/account-config');
  return data;
};

/** AccountConfig 생성 */
export const createAccountConfig = async (
  body: AccountConfigCreate,
): Promise<AccountConfig> => {
  const { data } = await api_.post<AccountConfig>('admin/account-config', body);
  return data;
};

/** AccountConfig 수정 */
export const updateAccountConfig = async (
  body: AccountConfigUpdate,
): Promise<AccountConfig> => {
  const { data } = await api_.patch<AccountConfig>(
    `admin/account-config/${body._id}`,
    body,
  );
  return data;
};

/** AccountConfig 삭제 */
export const deleteAccountConfig = async (id: string): Promise<void> => {
  await api_.delete(`admin/account-config/${id}`);
};
